import {Component, OnInit} from '@angular/core';
import {UtilService} from "../../services/util.service";
import {AuthService} from "../../services/auth.service";
import {AlertService} from "../../services/alert.service";
import {SessionService} from "../../services/session.service";

@Component({
    selector: 'rr-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

    private env: string;

    constructor(private authService: AuthService,
                private alertService: AlertService,
                private sessionService: SessionService,
                private utilService: UtilService) {
    }

    ngOnInit(): void {
        this.sessionService.sessionExpired().subscribe(() => {
            this.alertService.warn("Your session has been idle too long, so you have been logged out");
            this.authService.logOutThenCleanUpAndRedirect();
        });
        // If user is already logged in when header is loaded (typically a page reload), then start a session here, so the auto-logout
        // logic gets activated
        this.sessionService.restartSession();
        // Get current environment and remember it
        this.authService.getEnvironment()
            .subscribe((env) => {
                this.env = env;
            });
    }

    envLabel(): string {
        return this.env != 'prod'? this.env : '';
    }

    isLoggedIn(): boolean {
        return this.utilService.isLoggedIn();
    }

    logOut() {
        this.alertService.confirm("Are you sure you want to log out?")
            .subscribe((sure:boolean) => {
                if (sure)
                    this.authService.logOutThenCleanUpAndRedirect();
            });
    }
}
